const subscriptions = [
	{
		path: '/tv/subscriptions',
		name: 'tv-subscriptions-list',
		component: () => import('@/views/tv/subscriptions/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGTV,subscribers',
		},
	},
]

export default subscriptions
